import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { IMessageDialogData } from './message-dialog-data.interfcae';

@Component({
    selector: 'message-dialog',
    templateUrl: 'message-dialog.component.html',
    styleUrls: ['./message-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, MatIconModule]
})

export class MessageDialog {
    constructor(
      public dialogRef: MatDialogRef<MessageDialog>,
      @Inject(MAT_DIALOG_DATA) public data: IMessageDialogData,
    ) {}
  
}